/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-02 14:22:12
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-24 17:57:30
 */
import Vue from 'vue';
// 引入路由开始
import VueRouter from 'vue-router';
import afterSales from './after-sales';
import home from './home';
import CommodityCenter from './commodity-center';
import { deepClone } from '@/utils'
import Order from './order';
import Supplier from './supplier';
import stockControl from './stock-control';
import salesAnalysis from './sales-analysis';
import marketing from './marketing';
import configManage from './config-manager'
import customer from './customer';
import storeList from './store';
import Employee from './employee';
import album from './album';
import dataAnalysis from './data-analysis';
import errPage from './err-page';
import dashboard from './dashboard';
import operation from './operation';
import operateAnalysis from './operate-analysis';
import messageCenter from './message-center';
import userGuidance from './user-guidance';
import purchase from './purchase';
import systemManager from './system-manager';
import scAnalysis from './sc-analysis';
import paypal from './paypal';
import setting from './setting';
// 引入路由结束
import store from '../store';
import Cookies from 'js-cookie';
import {
  getAuthorityMenu,
} from '../server/common';
import { postLogin } from '../server/login';
import { getSession, _local } from '@/utils/storage';
import { generalPageName, noContractPage, personalPage } from '../utils/dict';
import { clearAllCookie, listToTree, getQueryParams, passwordEncrypt } from '@/utils/index';
import { global } from './global'
import { menuMap } from '@/lib/menuFormat';
const index = () => import('../views/login/index.vue');
const login = () => import('../views/login/login.vue');
const Layout = () => import('../layout/main.vue');
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: '/index',
    meta: {
      keepAlive: false
    },
    children: [
      ...operateAnalysis,
      ...configManage,
      ...afterSales,
      ...home,
      ...dashboard,
      ...CommodityCenter,
      ...Order,
      ...customer,
      ...storeList,
      ...marketing,
      ...errPage,
      ...Employee,
      ...dataAnalysis,
      ...Supplier,
      ...operation,
      ...salesAnalysis,
      ...userGuidance,
      ...stockControl,
      ...purchase,
      ...systemManager,
      ...messageCenter,
      ...album,
      ...scAnalysis,
      ...paypal,
      ...setting,
      {
        path: '/index',
        name: 'index',
        meta: {
          name: '首页',
          keepAlive: false
        },
        component: index,
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          name: '初始页',
          keepAlive: false
        },
        component: login,
      },
      {
        path: '/reptile',
        name: 'reptile',
        meta: {
          name: '爬虫',
          keepAlive: true
        },
        component: () => import('../views/other/reptile.vue'),
      },
    ],
  },
  ...global
];
const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});


const getAuthority = async to => {
  let authorityList = store.state.user.authorityList || [];
  if (authorityList.length === 0 && !store.state.user.isExpired) {

    authorityList = store.state.user.authorityList;
  }
  // 如果为白名单的路由不走权限
  if (generalPageName.includes(to.name)) {
    return true;
  }
  return hasAuthorityPage(authorityList, to);
};
// 判断当前商家是否有套餐权限
const hasSystemStatus = async (to) => {
  if (noContractPage.includes(to.name)) {
    return false
  } else {
    return store.state.user.isExpired
  }
}
router.beforeEach(async (to, from, next) => {
  try {
    store.commit('setVisable', false);
    if (document.body.className === 'body-loading-content') {
      document.body.className = '';
    }
  } catch (e) {
    console.log(e);
  }
  if (['pearlgo-login', 'zhizh-login', 'gule-login'].includes(to.name)) {
    next();
    return;
  }
  // const isDemo = window.location.search.includes('isDemo')
  // if (isDemo) {
  //   await goDemo()
  //   return;
  // }

  if (to.query && to.query.utm_source) {
    console.log('queryBuried');
    await store.dispatch('queryBuried', {
      event: 'PageView',
      page_name: to.meta.name,
      referrerPageName: from.meta.name,
      ...to.query,
    });
  }

  if (
    to.query &&
    to.query.language &&
    to.query.language !== getSession('language')
  ) {
    store.commit('changeLanguage', to.query.language);
    setTimeout(() => {
      window.location.reload();
    });
  }
  if (to.matched.length === 0) {
    from.name && from.name !== 'index' ? next({ name: from.name }) : next('/404');
  }
  const token = to.query && to.query.token;
  //paypal 回调回来会带一个他的merchantId需要获取
  const merchantId = to.query && !to.query.merchantIdInPayPal && to.query.merchantId;
  const isContrat = await hasSystemStatus(to);
  const isAuthority = await getAuthority(to);
  const nextfn = () => {
    if (isContrat) {
      next('/expired')
    } else if (!isAuthority && to.name !== null) {
      next('/authority');
    } else if (token || merchantId) {
      // store.commit('setRouterList', to)
      // 个人中心回跳BI时，避免重新登陆并携带跳入个人中心前的query参数
      let query = { ...to.query }
      delete query.token
      delete query.merchantId
      delete query.userId
      delete query.name
      delete query.preAccount
      delete query.backUrl
      next({ path: to.path, query });
    } else {
      store.commit('setRouterList', to)
      next();
    }
  };
  nextfn()

});
router.afterEach(async (to, from) => {
  Vue.prototype.$hasInitZIndex = false;
  if (!['zhizh-login', 'pearlgo-login', 'gule-login', 'reptile'].includes(to.name)) {
    store.dispatch('buried', {
      event: 'PageView',
      page_name: to.meta.name,
      referrerPageName: from.meta.name,
    });
  }
  document.title = Cookies.get('language') === 'en'
    ? 'Shoplus BI - More professional and efficient cross-border electricity supplier operating a full link data platform'
    : 'Shoplus BI - 更专业高效的跨境电商经营全链路数据平台';
  store.commit('setVisable', true);
});
function hasAuthorityPage(authorityList = [], to) {
  // 路由meta 携带parentsName的路由，只要权限菜单有该路由父级权限子路由可访问
  if (to.meta.parentsName) {
    return authorityList.some(
      item =>
        item.actionCode &&
        item.actionCode.split('::').pop() === to.meta.parentsName
    );
  } else {
    return authorityList.some(
      item => item.actionCode && item.actionCode.split('::').pop() === to.name.split("::")[0]
    );
  }
}
const goDemo = async () => {
  const { data } = await postLogin({
    login_id: '18922345926',
    password: passwordEncrypt('as123456'),
    is_seven_login: 0,
    login_type: 3,
    req_type: '登录'
  })
  if (data.code === 0) {
    const { token, nickName, userId } = data.data
    const params = `token=${token}&name=${nickName}&userId=${userId}`
    _local.set('userName', nickName)
    _local.set('userId', userId)
    store.commit('user.setUserName')
    window.location.href = `${window.location.origin}/?${params}`
  } else {
    setTimeout(() => {
      window.location.href = process.env.VUE_APP_LOGINURL
    }, 1000)
  }
}
export default router;
